module.exports = __webpack_public_path__ + "static/media/BLACK-HANDS.246f15bb.png";